module.exports = __webpack_public_path__ + "img/61.ca467486.png";